import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import classNames from '../../helpers/classNames';
import useTranslate from '../../hooks/useTranslate';
import { InspirationType } from '../../services/apis/inspirations/types';
import styles from './InspirationHeader.module.scss';

interface InspirationHeaderProps {
  inspiration: InspirationType;
}

const InspirationHeader: FC<InspirationHeaderProps> = props => {
  const { inspiration } = props;
  const { translate, activeLanguage } = useTranslate();

  return (
    <div className={classNames(styles.container, 'mb-5')}>
      <NavLink to={`/${activeLanguage.code}/inspirations/`}>
        {String(translate('Inspirations.title'))}
      </NavLink>
      <span>/</span>
      <NavLink to={`/${activeLanguage.code}/inspirations?category=${inspiration.category}`}>
        {String(translate(`Inspirations.categories.${inspiration.category}`))}
      </NavLink>
    </div>
  );
};

export default InspirationHeader;
